/**
 * 主题落地到 DOM 的唯一出口
 *
 * 项目自身用 [data-theme='dark'] 切换 CSS 变量；
 * Element Plus 的深色主题依赖 html.dark 类名（theme-chalk/dark/css-vars.css）。
 * 两者必须同步，否则会出现「页面深色、弹窗浅色」的割裂，所以统一走这里。
 */
export type ThemeName = 'light' | 'dark'

/** 主题持久化 key */
export const THEME_KEY = 'niuren-theme'

export function applyThemeToDocument(t: ThemeName) {
  localStorage.setItem(THEME_KEY, t)
  const el = document.documentElement
  el.setAttribute('data-theme', t)
  el.classList.toggle('dark', t === 'dark')
}

export function readStoredTheme(): ThemeName {
  return (localStorage.getItem(THEME_KEY) as ThemeName) || 'light'
}
